import axiosInstance from "../lib/axios.instance";
import {
  ChatHistoryRequest,
  ChatHistoryResponse,
  ChatQueryRequest,
  ChatQueryResponse,
  ISubmitFeedbackRequest,
  ISubmitFeedbackResponse,
  ICreateRequestRequest,
  ICreateRequestResponse,
} from "../types/discuss.types";

const BASE_URL = "/ai/chat";
const FEEDBACK_ENDPOINT = "/documents/feedback/";

/**
 * Get chat history for a document
 */
export const getChatHistory = async (payload: ChatHistoryRequest): Promise<ChatHistoryResponse> => {
  try {
    const response = await axiosInstance.post<ChatHistoryResponse>(`${BASE_URL}/get_chat`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || error.message || "Failed to fetch chat history"
    );
  }
};

/**
 * Send a chat message and get AI response
 */
export const sendChatMessage = async (payload: ChatQueryRequest): Promise<ChatQueryResponse> => {
  try {
    const response = await axiosInstance.post<ChatQueryResponse>(`${BASE_URL}/query`, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || error.message || "Failed to send chat message"
    );
  }
};

/**
 * Get chat history for a specific document using hardcoded document ID
 */
export const getDiscussChatHistoryForDocument = async (
  documentId: string = "6841b01bed7123bbec55498a"
): Promise<ChatHistoryResponse> => {
  const payload: ChatHistoryRequest = {
    current_document_id: documentId,
    document_id: [documentId],
  };

  return getChatHistory(payload);
};

/**
 * Submit feedback/rating for AI response
 */
export const submitFeedback = async (
  payload: ISubmitFeedbackRequest
): Promise<ISubmitFeedbackResponse> => {
  try {
    const response = await axiosInstance.post<ISubmitFeedbackResponse>(FEEDBACK_ENDPOINT, payload);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || error.message || "Failed to submit feedback");
  }
};

/**
 * Create a request in the request library
 */
export const createRequest = async (
  payload: ICreateRequestRequest
): Promise<ICreateRequestResponse> => {
  try {
    const response = await axiosInstance.post<ICreateRequestResponse>(
      `${BASE_URL}/request`,
      payload
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || error.message || "Failed to create request");
  }
};
